import * as React from "react";
import { Box, Grid } from "@material-ui/core";
import { SvgIcon } from "../../../../components/SvgIcon";
import { themeVariables } from "..";
import * as styles from "./styles.scss";

interface IProps {
  lesson: { type: string; name: string };
  small?: boolean;
  big?: boolean;
}

export const MUILessonCard = (props: IProps) => {
  const { lesson, small, big } = props;
  const getBG = () => {
    switch (lesson.type) {
      case "task":
        return themeVariables.palette.warning.light;
      case "theory":
        return themeVariables.palette.info.light;
      case "webinar":
        return themeVariables.palette.error.light;
      case "test":
        return themeVariables.palette.success.light;
      default:
        null;
    }
  };
  return lesson ? (
    <Grid
      container
      spacing={1}
      alignItems="center"
      justifyContent={big ? "flex-start" : "center"}
      wrap="nowrap"
    >
      <Grid item>
        <Box className={`${styles.lessonType}`} bgcolor={getBG()}>
          <SvgIcon type={`lessontype_${lesson.type}`} />
        </Box>
      </Grid>
      <Grid item>
        <Box
          className={`${styles.lessonName} ${small ? styles.lessonNameXs : ""}${
            !big && !small ? styles.lessonNameMd : ""
          }
`}
          title={lesson.name}
        >
          {lesson.name}
        </Box>
      </Grid>
    </Grid>
  ) : null;
};
